// src/utils/url.ts
import { Capacitor } from "@capacitor/core";

// L'app mobile Capacitor sert les pages depuis capacitor://localhost, qui n'est pas
// une URL joignable depuis l'extérieur (lien d'invitation, partage, etc.).
// On force donc l'URL publique de prod dès qu'on tourne en app native.
const NATIVE_APP_URL = "https://swishdata.app";

export function getAppBaseUrl(): string {
  if (Capacitor.isNativePlatform()) {
    return NATIVE_APP_URL;
  }

  // CRA injects REACT_APP_* at build-time. At runtime, `process` may not exist in some setups,
  // so we must guard the identifier itself.
  const hasProcess = typeof process !== "undefined" && typeof process.env !== "undefined";

  const fromEnv =
    (hasProcess && process.env.REACT_APP_PUBLIC_APP_URL) ||
    (hasProcess && process.env.PUBLIC_URL) ||
    "";

  // Fallbacks
  const base =
    (fromEnv && fromEnv.trim().length > 0
      ? fromEnv
      : typeof window !== "undefined" && window.location
      ? window.location.origin
      : "");

  return String(base).replace(/\/+$/, "");
}
